import { render, staticRenderFns } from "./PlatonNotFoundPage.vue?vue&type=template&id=2c1f00af&scoped=true&"
import script from "./PlatonNotFoundPage.vue?vue&type=script&lang=js&"
export * from "./PlatonNotFoundPage.vue?vue&type=script&lang=js&"
import style0 from "./PlatonNotFoundPage.vue?vue&type=style&index=0&id=2c1f00af&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1f00af",
  null
  
)

export default component.exports